import React, { PropsWithChildren } from 'react'
import { createContext } from 'lib/createContext'
import { useShiftDetailContextValue } from 'pages/Shifts/ShiftDetail/context/ShiftDetailProvider'
import { useShiftAnalysisQuery } from 'queries/shifts/useShiftAnalysisQuery'
import { parseErrorMessage } from 'api'

type SummaryScreenContextState = {
  actions: {
    refetch: () => void
  }
  state: {
    data: NonNullable<ReturnType<typeof useShiftAnalysisQuery>['data']>
    isLoading: boolean
    isSuccess: boolean
    isError: boolean
    errorMessage: string | undefined
  }
}

const [Context, useSummaryScreenContextValue] =
  createContext<SummaryScreenContextState>({
    name: 'SummaryScreenContext',
  })

export const ShiftAnalystScreenContextProvider = ({
  children,
}: PropsWithChildren) => {
  const {
    state: { id: shiftId },
  } = useShiftDetailContextValue()

  const { data, isFetching, isSuccess, isError, error, refetch } =
    useShiftAnalysisQuery({
      shiftId,
    })

  const value: SummaryScreenContextState = {
    actions: {
      refetch,
    },
    state: {
      data: data ?? [],
      isLoading: isFetching,
      isSuccess,
      isError,
      errorMessage: parseErrorMessage(error),
    },
  }
  return <Context.Provider value={value}>{children}</Context.Provider>
}
export { useSummaryScreenContextValue }
